module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welcome f18"
  }, [_vm._v("\n  " + _vm._s(_vm.message) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-383c8d0c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = 322
// module chunks = 1